module.exports = __webpack_public_path__ + "static/img/guide_img_2.aed74f71.jpg";